import axiosInstance from '@/services/axiosInstance';

// Funkce pro generování barvy avatara
export const getAvatarColor = (firstName: string, lastName: string) => {
    const fullName = `${firstName} ${lastName}`;
    let hash = 0;
    
    // Jednoduché hashování jména
    for (let i = 0; i < fullName.length; i++) {
      hash = fullName.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    // Převod hash hodnoty na hexadecimální barvu
    const color = '#' + ((hash >> 24) & 0xFF).toString(16).padStart(2, '0') +
                        ((hash >> 16) & 0xFF).toString(16).padStart(2, '0') +
                        ((hash >> 8) & 0xFF).toString(16).padStart(2, '0');
    
    return color;
  };


type CanModifyOpts = {
  requiredOneOfRole?: string[]; // např. ['administrator','coach','league-admin']
  teamId?: string | null;
  eventId?: string | null;
  leagueId?: string | null;
};

/**
 * Vrátí true/false podle toho, jestli má přihlášený uživatel (token v axiosInstance)
 * požadovaná oprávnění nebo vazby (league/team/event).
 *
 * Příklady:
 *  await canModify({ requiredOneOfRole: ['administrator','coach'] })
 *  await canModify({ teamId: someTeamId, requiredOneOfRole: ['team-admin'] })
 *  await canModify({ eventId, requiredOneOfRole: ['timekeeper','league-admin'] })
 */
export const canModify = async ({
  requiredOneOfRole = [],
  teamId = null,
  eventId = null,
  leagueId = null,
}: CanModifyOpts): Promise<boolean> => {
  try {
    const params: Record<string, any> = {};
    if (requiredOneOfRole.length) params.required = requiredOneOfRole.join(',');
    if (teamId) params.teamId = teamId;
    if (eventId) params.eventId = eventId;
    if (leagueId) params.leagueId = leagueId;

    const { data } = await axiosInstance.get('/users/getpermission', { params });
    //console.log('canModify data:', data);
    // backend posílá { allowed: boolean, reason?: string, ... }
    return !!data?.allowed;
  } catch (e) {
    console.error('canModify error:', e);
    return false;
  }
};